import { useTranslation } from "react-i18next";
import React from "react";

export function useProducts() {
  const { t } = useTranslation();

  const products = React.useMemo(
    () => [
      {
        id: "furniture",
        name: t("categories.furniture"),
        description: t("categories.decorationsDescription", {
          defaultValue:
            "Furniture selections to elevate your event (tables, chairs, sofas, lounge, decorative setup).",
        }),
        imageUrl:
          "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Mobilier.png",
      },
      {
        id: "structuresAndTents",
        name: t("categories.structuresAndTents"),
        description: t("categories.structuresAndTentsDescription", {
          defaultValue:
            "Tents, marquees, flooring, risers and stages to shape your spaces.",
        }),
        imageUrl:
          "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Structures%20et%20tentes.png",
      },
      {
        id: "lightingAndEffects",
        name: t("categories.lightingAndEffects"),
        description: t("categories.lightingAndEffectsDescription", {
          defaultValue:
            "Architectural/ambient lighting, string lights and light special effects.",
        }),
        imageUrl:
          "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/eclairageeteffets.webp",
      },
      {
        id: "technologyAndAV",
        name: t("categories.technologyAndAV"),
        description: t("categories.technologyAndAVDescription", {
          defaultValue:
            "State-of-the-art audio and visual equipment (screens, projectors, microphones).",
        }),
        imageUrl:
          "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Technologie%20et%20audiovisuel%20(3).png",
      },
      {
        id: "photographyAndVideography",
        name: t("categories.photographyAndVideography"),
        description: t("categories.photographyAndVideographyDescription", {
          defaultValue:
            "Photobooth kits, backdrops, visual props, supports and capture accessories.",
        }),
        imageUrl:
          "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Photographieetvideographie.png",
      },
      {
        id: "merchAndGifts",
        name: t("categories.merchAndGifts"),
        description: t("categories.merchAndGiftsDescription", {
          defaultValue:
            "Custom favors, stationery, labels and branded merchandise.",
        }),
        imageUrl:
          "https://ldgsoggxiujexptwxyar.supabase.co/storage/v1/object/public/makeadream-images/Categories/Produitspersonnalisesetcadeaux.png",
      },
    ],
    [t]
  );

  return products;
}
